import { SessionContextProps } from "../../../../Context/SessionContext";
import DispositionScenarioFilter from "./DispositionScenarioFilter";

/** The properties of the current session which are available to the scenario when making logical decisions. */
export interface IDispositionScenarioSessionProps
  extends Pick<
    SessionContextProps,
    | "appointment"
    | "customer"
    | "lead"
    | "isLeadManualOutbound"
    | "isSessionShortCircuited"
    | "leadDisqualifiers"
    | "selectedCustomer"
  > {
  /** A flag indicating if the user has confirmed that a booking was made when the application has no record of the event. */
  isBookingManuallyConfirmed: boolean;
}

/** A callback which returns true if the disposition scenario is applicable to the session, false otherwise. */
export type DispositionScenarioConstraint = (props: IDispositionScenarioSessionProps) => boolean;

/** A scenario which controls the experience of the disposition step when a constraint regarding the sessions's state
 * is met.
 */
class DispositionScenario {
  /** The constraint which must be met for the scenario to be applicable to the session's disposition step. */
  readonly constraint: DispositionScenarioConstraint;
  /** The filter which limits the lead result type options selectable by the user in the disposition step. */
  readonly optionsFilter: DispositionScenarioFilter;

  constructor(constraint: DispositionScenarioConstraint, optionsFilter: DispositionScenarioFilter) {
    this.constraint = constraint;
    this.optionsFilter = optionsFilter;
  }
}

export default DispositionScenario;
